export const START_APP = 'START_APP';

export const UPLOADING = 'UPLOADING';

export const UPLOADED = 'UPLOADED';

export const SEEK_URI= 'SEEK_URI';

export const GET_RESULT = 'GET_RESULT';
